import React from "react";
import { ComponentEventHandler, Form , Input, Button } from "@fluentui/react-northstar";
import uf from "usefuljs";
import {FbAcc} from "@interfaces/acc";
import styles from "./info.module.scss";

type InfoProps = {
    user_acc: FbAcc
}


const Info = (props:InfoProps)=>{
    const [name,setName] = React.useState(props.user_acc.fb_acc);
    const [endpoint,setEndpoint] = React.useState(props.user_acc.endpoint);
    const [email,setEmail] = React.useState("");
    const [password,setPassword] = React.useState("");
    // for loading
    const [loggingIn,setLoggingIn] = React.useState(false);
    const [fetchingAcc,setFetchingAcc] = React.useState(false);
    
    React.useEffect(()=>{
        // updated props, user switched to another fb_acc
        setName(props.user_acc.fb_acc);
        setEndpoint(props.user_acc.endpoint);
        setEmail("");
        setPassword("");
    },[props]);


    const onChangeName:ComponentEventHandler<HTMLInputElement> = e => {
        const ev = e.currentTarget as HTMLInputElement;
        setName(ev.value);
    }

    const onSaveName:ComponentEventHandler<HTMLButtonElement> = async _ =>{
        // - save name
        console.log(`TODO: update uid:${props.user_acc.uid} name to ${name}`);
        await uf.ajax({
            method:"post",
            url: "https://jennysss.lenx.ai/fbm/api/acc/fbacc/set",
            data: {
                uid: props.user_acc.uid,
                fbacc:name
            }
        }).catch(err=>{throw err})
        await uf.ajax({
            url: "https://jennysss.lenx.ai/fbm/api/acc/refresh"
        });
    }

    const onChangeEndpoint:ComponentEventHandler<HTMLInputElement> = e =>{
        const ev = e.currentTarget as HTMLInputElement;
        setEndpoint(ev.value);
    }

    const onSaveEndpoint:ComponentEventHandler<HTMLButtonElement> = async _ =>{
        // - save endpoint
        await uf.ajax({
            method:"post",
            url: "https://jennysss.lenx.ai/fbm/api/acc/endpoint/set",
            data: {
                uid: props.user_acc.uid,
                endpoint
            }
        }).catch(err=>{throw err})
        await uf.ajax({
            url: "https://jennysss.lenx.ai/fbm/api/acc/refresh"
        });
    }

    const onChangeEmail:ComponentEventHandler<HTMLInputElement> = e =>{
        const ev = e.currentTarget as HTMLInputElement;
        setEmail(ev.value);
    }

    const onChangePassword:ComponentEventHandler<HTMLInputElement> = e =>{
        const ev = e.currentTarget as HTMLInputElement;
        setPassword(ev.value);
    }

    const onLogin:ComponentEventHandler<HTMLButtonElement> = async _ =>{
        setLoggingIn(true);
        await uf.ajax({
            method:"post",
            url: "https://jennysss.lenx.ai/fbm/api/acc/fbacc/login",
            data: {
                email,
                password,
                fb_acc: name,
            }
        }).catch(err=>{throw err}).finally(()=>{setLoggingIn(false)});
        await onClickFetchAcc().catch(err=>{throw err});
    }


    const onClickFetchAcc = async () =>{
        setFetchingAcc(true);
        try{
            await uf.ajax({
                url: "https://jennysss.lenx.ai/fbm/api/acc/fetch",
                data: {
                    fb_acc: name
                }
            });
            await uf.ajax({
                url: "https://jennysss.lenx.ai/fbm/api/acc/refresh"
            });
        }catch(err){throw err}finally{setFetchingAcc(false)};
        
    }

    return (
        <div id={styles.info}>
            <div className={styles.form_row}>
                <Form
                    fields={
                        [
                            {
                                label: "Name",
                                name: "name",
                                key: "name",
                                control: {
                                    as: Input,
                                    showSuccessIndicator: false,
                                    value: name,
                                    onChange: onChangeName
                                },
                                inline:true
                            },
                            {
                                key:"save_name",
                                control: {
                                    as: Button,
                                    content: "Save",
                                    onClick: onSaveName
                                }
                            }
                        ]
                    }
                />
            </div>

            <div className={styles.form_row}>
                <Form
                    fields={
                        [
                            {
                                label: "Endpoint",
                                name: "endpoint",
                                key: "endpoint",
                                control: {
                                    as: Input,
                                    showSuccessIndicator: false,
                                    value: endpoint,
                                    onChange: onChangeEndpoint
                                },
                                inline:true
                            },
                            {
                                key:"save_endpoint",
                                control: {
                                    as: Button,
                                    content: "Save",
                                    onClick: onSaveEndpoint
                                }
                            }
                        ]
                    }
                />

            </div>

            <div className={styles.form_row}>
                {
                    loggingIn ? "Logging In ..." :
                    <Form
                        fields={
                            [
                                {
                                    label: "Email",
                                    name: "email",
                                    key: "email",
                                    control: {
                                        as: Input,
                                        showSuccessIndicator: false,
                                        value: email,
                                        onChange: onChangeEmail
                                    },
                                    inline:true
                                },
                                {
                                    label: "Password",
                                    name: "password",
                                    key: "password",
                                    control: {
                                        as: Input,
                                        showSuccessIndicator: false,
                                        value: password,
                                        onChange: onChangePassword
                                    },
                                    inline:true,
                                    type:"password",
                                },
                                {
                                    key:"action_login",
                                    control: {
                                        as: Button,
                                        content: "Login",
                                        onClick: onLogin
                                    }
                                }
                            ]
                        }
                    />
                }
                
            </div>

            <div className={styles.form_row}>
                {
                    fetchingAcc ? "Fetching cookies ..." :
                    <Form
                        fields={
                            [
                                {
                                    label: "Cookies",
                                    name: "cookies",
                                    key: "cookies",
                                    control: {
                                        as: Button,
                                        content: "Fetch",
                                        onClick: onClickFetchAcc
                                    }
                                }
                            ]
                        }
                    />
                }
                

            </div>
        </div>
    )
}


export default Info;
